import {
  type Brand,
  type Country,
  createUrlResolver,
} from '@seek/melways-sites';
import { getLanguage, getLocale, getSite } from 'src/config';
import {
  EDIT_URL_SUBPATH,
  PREVIEW_URL_SUBPATH,
  URL_BRAND_REPORT,
  URL_CREATE_BRAND,
  URL_EDIT_BRAND,
  URL_LIST_BRANDS,
  URL_PREVIEW_BRAND,
} from '../constants/urls';

export const getUrl = (path: string) => {
  const site = getSite();
  const language = getLocale();

  const resolveUrl = createUrlResolver({
    site,
    language,
  });

  return resolveUrl({
    language,
    path,
  });
};

export const getEditUrl = () => getUrl(URL_EDIT_BRAND);

export const getEditSubpathUrl = () => getUrl(EDIT_URL_SUBPATH);

export const getEditUrlForId = (brandId: string) =>
  `${getEditUrl()}`.replace(':id', brandId);

export const getPreviewUrl = () => getUrl(URL_PREVIEW_BRAND);

export const getPreviewSubpathUrl = () => getUrl(PREVIEW_URL_SUBPATH);

export const getPreviewUrlForId = (brandId: string) =>
  getPreviewUrl().replace(':id', brandId);

export const getListUrl = () => getUrl(URL_LIST_BRANDS);

export const getCreateUrl = () => getUrl(URL_CREATE_BRAND);

export const getBrandReportUrl = () => getUrl(URL_BRAND_REPORT);

export const auBrandingGuidelinesUrl =
  'https://help.seek.com.au/employer/s/article/SEEK-Ad-Branding-Guidelines';
export const getBrandingGuidelinesUrl = () => {
  const site = getSite();
  const language = getLanguage();

  switch (site) {
    case 'employer-seek-nz':
      return 'https://help.seek.co.nz/employer/s/article/SEEK-Ad-Branding-Guidelines-NZ';
    case 'employer-seek-ph':
      return 'https://help.ph.employer.seek.com/s/article/SEEK-Ad-Branding-Guidelines-NZ';
    case 'employer-seek-sg':
      return 'https://help.sg.employer.seek.com/s/article/SEEK-Ad-Branding-Guidelines-NZ';
    case 'employer-seek-my':
      return 'https://help.my.employer.seek.com/s/article/SEEK-Ad-Branding-Guidelines-NZ';
    case 'employer-seek-id':
      return language === 'id'
        ? 'https://help.id.employer.seek.com/id/s/article/SEEK-Ad-Branding-Guidelines-NZ?language=in'
        : 'https://help.id.employer.seek.com/s/article/SEEK-Ad-Branding-Guidelines-NZ';
    default:
      return auBrandingGuidelinesUrl;
  }
};

export const BRAND_INFO: { [key in Country]: Brand } = {
  hk: 'jobsdb',
  id: 'jobstreet',
  my: 'jobstreet',
  ph: 'jobstreet',
  sg: 'jobstreet',
  th: 'jobsdb',
  au: 'seek',
  nz: 'seek',
};
